module.exports = __webpack_public_path__ + "static/media/5.497eb243.jpg";